import mixin from "@/mixins/index";
// 验证ip
const vaildateIp = (ip) => {
  const str = /([0-9]{1,3}\.{1}){3}[0-9]{1,3}/.exec(ip);
  //不匹配和匹配的字符串与ip不同则返回false
  return !str || str[0] != ip ? false : true;
};
export default {
  getters: {
    seriesError: (state) => ({
      name: !state.seriesParams.name,
      // campaignType: !state.seriesParams.campaignType && state.seriesParams.autoCampaignType != 1,
      // clickUrl: !state.seriesParams.clickUrl && state.seriesParams.autoCampaignType != 1,
      dailyBudget:
        state.seriesParams.dailyBudgetValue.length &&
        state.seriesParams.dailyBudgetValue == 0,
      totalBudget:
        state.seriesParams.totalBudget.length &&
        state.seriesParams.totalBudget == 0,
      promotionType: !state.seriesParams.promotionType,
      appId: !state.seriesParams.appId,
    }),
    campaignError: (state) => ({
      seriesId: !state.seriesParams.id,
      targetIps: (() => {
        console.log(state);
        if (state.campaignParams.targetIpsType == 0) return false;
        //每一项都验证通过则返回false
        //都为空或都验证通过
        const bool = state.ipList.every(
          (item) =>
            (!item.start && !item.end) ||
            (vaildateIp(item.start) && vaildateIp(item.end))
        );
        return !bool;
      })(),
      targetSourceChannelIds: !state.campaignParams.targetSourceChannelIds
        .length,
      name: !state.campaignParams.name && !state.campaignParams.batch,
      bidPrice: (() => {
        //内部不做限制
        // if (state.userInfo.source == 'batmobi') return !parseFloat(state.campaignParams.bidPrice);
        // if (state.campaignParams.bidType == 1) return !(parseFloat(state.campaignParams.bidPrice) >= 0.01);
        // if (state.campaignParams.bidType == 2) return !(parseFloat(state.campaignParams.bidPrice) >= 0.03);
        // if (state.campaignParams.bidType == 3) return !(parseFloat(state.campaignParams.bidPrice) >= 0.0006);
        if (!String(state.campaignParams.bidPrice).trim()) {
          return true;
        }
      })(),
      dailyBudget:
        (!state.campaignParams.dailyBudgetValue &&
          state.campaignParams.speed == 2) ||
        (state.campaignParams.dailyBudgetValue.length &&
          state.campaignParams.dailyBudgetValue == 0),
    }),
    creativeError: (state) => {
      return {
        campaignId: !state.campaignParams.id,
        1: !state.imgList.length,
        2: (() => {
          if (
            state.status.type == "creative" &&
            state.status.action == "edit"
          ) {
            const item = JSON.parse(JSON.stringify(state.creativeParams[0]));
            return (
              !item.title ||
              item.title.length > 50 ||
              !item.description ||
              item.description.length > 200 ||
              !item.buttonText ||
              item.buttonText.length > 11 ||
              !item.imgUrl ||
              !item.iconUrl
            );
          }
          return (
            !state.infoList.length ||
            state.infoList.some(
              (item) =>
                !item.title ||
                item.title.length > 50 ||
                !item.description ||
                item.description.length > 200 ||
                !item.buttonText ||
                item.buttonText.length > 11 ||
                !item.imgUrl ||
                !item.iconUrl
            )
          );
        })(),
        4: !state.bannerList.every((item) => {
          const imgList = item.imgList
            ? item.imgList.filter((img) => img.imgUrl)
            : [];
          let bool =
            imgList.length >= 2 &&
            imgList.every((img) => img.sizeType == item.sizeType);
          //轮播样式额外验证bg尺寸
          if (item.animation == 2)
            bool = bool && (!item.bgUrl || item.bgSizeType == item.sizeType);
          return bool;
        }),
        11:
          !state.htmlList[0].name ||
          (!mixin.methods.mixinUrlReg(state.htmlList[0].h5Url) &&
            state.htmlList[0].h5Type == 1) ||
          (!mixin.methods.mixinUrlReg(state.seriesParams.clickUrl) &&
            state.htmlList[0].h5Type == 2),
      };
    },
  },
  state: {
    userInfo: {
      accountType: "",
      email: "",
      source: "",
      autoType: 0,
    },
    //新建/编辑/复制 广告系列/广告组/广告
    status: {
      action: "add",
      type: "series",
      id: "",
    },
    //广告类型
    creativeType: 2,
    seriesTypeOptions: [
      {
        label: "应用推广",
        value: 1,
      },
      {
        label: "网站推广",
        value: 2,
      },
    ],
    // 应用（网站）关联
    relatedOptions: [],
    //广告系列参数
    seriesParams: {
      autoCampaignType: 0, //推广类型，0:手动推广，1:自动推广
      offerBundleStatus: 1, //自动推广包名状态 0下线,1在线
      name: "", //名称
      // appBundle: '', //包名
      // campaignType: '',
      // clickUrl: '', //落地页
      dailyBudgetType: "dailyBudget",
      dailyBudgetValue: "",
      dailyBudget: 0, //日预算
      dailyClick: 0, //日点击
      dailyImp: 0, //日展示
      totalBudget: "", //总预算
      frequencyType: 1,
      frequencyDimension: 1,
      frequencyTarget: 1,
      frequency: "", //频次
      // impCallbackUrl: '', //展示回调
      // clickCallbackUrl: '', //展示回调
      status: 1, //状态 0:已停止 1:进行中(进行中且当前时间在start_day~end_day范围内才投放) 3归档
      dayType: 0, //日期类型 ：0长期 1指定
      level: 1, //处理层级 1.广告系列 2.广告组 3.广告
      startDay: mixin.methods.mixinGetDate("today"), //日期
      endDay: mixin.methods.mixinGetDate("day", 6), //日期
      promotionType: "", // 广告类型
      appId: "", // 关联应用（网站）
    },
    //广告组参数
    campaignParams: {
      translate: false,
      batch: false,
      name: "", //名称
      status: 1, //状态
      dealType: 0, //交易类型 0 RTB
      // bidType: 2, //出价类型 1 CPM , 2 CPA
      eventType: "", // 优化目标
      bidPrice: "", //出价,单位美分
      targetTime: "", //投放时间 多个逗号分隔 格式 星期1-7#开始时间#结束时间 eg. 1#0#24
      targetTimeType: 0,
      targetCountriesType: 0, //定向国家
      targetCountries: "",
      targetLanguagesType: 0, //定向语言
      targetLanguages: "",
      targetIpsType: 0, //定向Ip
      targetIps: "",
      targetOsType: 0, //定向系统
      targetOs: "",
      deviceType: 0, //设备类型
      connectionType: 0, //网络类型
      targetSourceChannelIds: [], //渠道ID
      targetCategoryType: 0, //定向媒体分类
      targetCategory: "",
      targetBundleType: 0, //定向媒体
      targetBundles: "",
      targetChannelType: 0, //子渠道定向
      targetChannels: "",
      speed: 1, //速度
      dailyBudgetType: "dailyBudget",
      dailyBudgetValue: "",
      dailyBudget: 0, //预算
      dailyClick: 0,
      dailyImp: 0,
      dailyImpCpmTimes: 0,
      totalBudget: 0,
      totalClick: 0,
      totalImp: 0,
      ruleIds: "", //优化规则

      pbidPrice: "", //投放出价
      pctr: "", //pctr：
      pcvr: "", //pcvr
      startTime: "", //影响开始时间
      endTime: "", //影响结束时间
      pbidPriceTime: "", //整体时间
      exposureRate: "", //补/扣曝光占比：
      clickRate: "", //补/扣点击占比：
    },
    // 广告组优化目标选项
    campaignOptimizationOptions: [],
    //批量广告组列表
    campaignBatchList: [],
    //创意参数
    creativeParams: [{}],
    //图片选择
    imgList: [],
    //视频选择
    videoList: [
      {
        creativeType: 3,
        title: "",
        description: "",
        status: 1,
        showFunction: false,
        sizeType: 3,
        imgUrl: "",
        videoUrl: "",
      },
    ],
    //信息流列表
    infoList: [],
    infoParams: {
      textList: [],
      imgList: [],
      nativeImgList: [],
      native_3ImgList: [],
    },
    //动图列表
    bannerList: [],
    //html列表
    htmlList: [
      {
        creativeType: 1,
        title: "",
        h5Type: 2,
        h5Url: "",
        status: 1,
        sizeType: 6,
      },
    ],
    ipList: [
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
    ],
    //广告系列列表
    seriesList: [],
    //广告组列表
    campaignList: [],
    //国家列表
    countryList: [],
    //语言列表
    languageList: [],
    //推广行业列表
    campaignTypeList: [],
    //系统列表
    osList: [],
    //渠道列表
    sourceList: [],
    //媒体分类列表
    categoryList: [],
    //媒体列表
    bundleList: [],
    //推广行业列表
    appList: [],
    //图片创意尺寸
    imgSizeList: { 1: "300x250", 5: "320x50", 6: "320x480" },
    //信息流创意尺寸
    infoImgSizeList: {
      1: "300x250",
      5: "320x50",
      6: "320x480",
      7: "1200x627",
      8: "320x200",
      9: "1200x628",
      10: "640x360",
    },
    //信息流文案长度限制
    infoMaxLength: {
      title: { require: 256, advise: 35 },
      description: { require: 512, advise: 80 },
      buttonText: { require: 12, advise: 12 },
    },
    //动图创意尺寸
    bannerSizeList: {
      1: { 1: "300x250", 5: "320x50", 6: "320x480" },
      2: { 1: "300x250", 6: "320x480" },
    },
    sizeList: {
      1: "300x250",
      5: "320x50",
      6: "320x480",
      7: "1200x627",
      8: "320x200",
      9: "1200x628",
      10: "640x360",
    },
    //按钮文案列表
    buttonTextList: [
      "Details",
      "Free",
      "Play Now",
      "Shop Now",
      "Install",
      "Download",
      "Learn More",
    ],
    //图片创意数据模板
    imgTemplate: {
      name: "",
      imgUrl: "",
      sizeType: 1,
      status: 1,
      creativeType: 1,
    },
    //信息流新建默认数据模板
    infoTemplate: {
      creativeType: 2,
      textList: [
        {
          title: "",
          description: "",
          buttonText: "",
          blurTitle: false,
          blurDescription: false,
          blurButtonText: false,
        },
      ],
      imgList: [
        // {
        //     name: '',
        //     imgUrl: '',
        //     sizeType: 2,
        //     showFunction: false,
        // },
      ],
      nativeImgList: [
        // {
        //     name: '',
        //     imgUrl: '',
        //     sizeType: 8,
        //     showFunction: false,
        // },
      ],
      native_3ImgList: [],
      iconUrl: "",
      status: 1,
    },
    //动图图片模板
    bannerImgListTemplate: {
      imgUrl: "",
      loading: false,
      function: false,
      sizeType: 1,
    },
    //动图新建默认数据模板
    bannerTemplate: {
      1: {
        creativeType: 4,
        animation: 1,
        speed: 500,
        sizeType: 1,
        transition: 0,
        imgUrl: "",
        status: 1,
        imgList: {},
      },
      2: {
        creativeType: 4,
        animation: 2,
        sizeType: 1,
        imgUrl: "",
        status: 1,
        imgList: {},
        bgUrl: "",
        bgSizeType: "1",
        bgLoading: false,
        bgFunction: false,
      },
    },
  },
  mutations: {
    userInfo(state, val) {
      state.userInfo = val;
    },
    status(state, val) {
      state.status = val;
    },
    seriesParams(state, val) {
      state.seriesParams = val;
    },
    campaignParams(state, val) {
      state.campaignParams = val;
    },
    creativeParams(state, val) {
      state.creativeParams = val;
    },
    campaignBatchList(state, val) {
      state.campaignBatchList = val;
    },
    infoParams(state, val) {
      state.infoParams = val;
    },
    seriesList(state, val) {
      state.seriesList = val;
    },
    campaignList(state, val) {
      state.campaignList = val;
    },
    countryList(state, val) {
      state.countryList = val;
    },
    languageList(state, val) {
      state.languageList = val;
    },
    campaignTypeList(state, val) {
      state.campaignTypeList = val;
    },
    appList(state, val) {
      state.appList = val;
    },
    ipList(state, val) {
      state.ipList = val;
    },
    osList(state, val) {
      state.osList = val;
    },
    sourceList(state, val) {
      state.sourceList = val;
    },
    categoryList(state, val) {
      state.categoryList = val;
    },
    bundleList(state, val) {
      state.bundleList = val;
    },
    creativeType(state, val) {
      state.creativeType = val;
    },
    imgList(state, val) {
      state.imgList = val;
    },
    videoList(state, val) {
      state.videoList = val;
    },
    infoList(state, val) {
      state.infoList = val;
    },
    bannerList(state, val) {
      state.bannerList = val;
    },
    htmlList(state, val) {
      console.log("vuex-htmllist", state);
      state.htmlList = val;
    },
    // 设置关联应用（网站）的选项
    setRelatedOptions(state, val) {
      state.relatedOptions = val;
    },
    // 设置关联应用（网站）
    setRelatedAppId(state, val) {
      state.seriesParams.appId = val;
    },
    // 设置广告组优化目标所选中的值
    setEventType(state, val) {
      state.campaignParams.eventType = val;
    },
    // 设置广告组优化目标选项
    setCampaignOptimizationOptions(state, val) {
      state.campaignOptimizationOptions = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/newPromotion.js